// List of currently supported unit types
// `allMeasures` includes all the measures packaged with this library

export function getMeasurementIdentifier(measurement) {
  return `${measurement.date}-${measurement.unit}-${
    measurement.value
  }-${measurement.note.slice(0, 500)}`;
}
